import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getVisitorId } from "../lib/visitor";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    axios
      .post(`${BACKEND_URL}/api/track`, {
        path: pathname,
        visitor_id: getVisitorId(),
        referrer: typeof document !== "undefined" ? document.referrer || "" : "",
      })
      .catch(() => {});
  }, [pathname]);
  return null;
};

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="app-layout">
      <ScrollToTop />
      <PageTracker />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
